import React from 'react';
import { Button } from '@material-ui/core';

const button = (props) => (
    <Button variant="contained" color="primary" type="button" onClick={props.clicked} disabled={props.disabled} style={props.style}>{props.children}</Button>
);

export default button;
